import { TRIGGER_FETCH_BANK_LIST_API, TRIGGER_FETCH_BANK_LIST_API_SUCCESS } from 'redux/actionTypes';

export function triggerFetchBankListApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_BANK_LIST_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchBankListApiCallSuccess(data) {
	return {
		type: TRIGGER_FETCH_BANK_LIST_API_SUCCESS,
		data,
	};
}
